import { combineReducers } from 'redux';
import lastPlayedSongs from './LastPlayedSongsReducer';
import aovivoNews from './AovivoNewsReducer';

const AoVivoCombined = combineReducers({
    lastPlayedSongs,
    aovivoNews,
});

export default AoVivoCombined;
